import {
  appRoutes,
  commonButtonMessages,
  commonErrorMessages,
  resetUserRegistrationState,
  signatureAreaUserRegistrationMessages,
  useUserRegistrationSignatureAreaLogic
} from 'azshared';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Card, CardSize } from '../../../../components/card/card';
import { AppLink } from '../../../../components/labels/app-link';
import { useGlobalActions, useGoToLoginFromRegistration } from '../../../../hooks/global-actions';
import { LoginContainer } from '../../login-container/login-container';
import { SignatureAreaDocument } from './components/document/signature-area-document';
import './signature-area-page.scss';
import { BannerCookiePolicy } from 'src/components/banner-cookie-policy/banner-cookie-policy';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../../hooks/redux';
import { AppDialog } from 'src/components/dialog/app-dialog';
import Icon from '@mdi/react';
import { mdiCloseCircleOutline } from '@mdi/js';
import { AppButton } from 'src/components/buttons/app-button';

export const SignatureAreaUserRegistrationPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const goToLoginFromRegistration = useGoToLoginFromRegistration();
  const { onAheadButtonPress, signIsExpired, document, isLoading } = useUserRegistrationSignatureAreaLogic(useGlobalActions());

  const { selectedOptionUserType } = useAppSelector((state) => state.features.userRegistration);

  const handleCloseSignExpiredPopup = useCallback(() => {
    dispatch(resetUserRegistrationState());
    navigate(appRoutes.Login);
  }, [dispatch, navigate, selectedOptionUserType]);

  return (
    <div>
      <LoginContainer>
        <div className='signature-area-user-registration-page'>
          <Card
            title={formatMessage(signatureAreaUserRegistrationMessages.pageTitle)}
            subtitle={formatMessage(signatureAreaUserRegistrationMessages.pageSubtitle)}
            sizeVariant={CardSize.MEDIUM}>
            <SignatureAreaDocument document={document} clickGoForward={onAheadButtonPress} isLoading={isLoading} />
            <div className='disclaimer'>
              {formatMessage(commonButtonMessages.linkBackToLogin)}
              <AppLink to={appRoutes.Login} replace={false} label={formatMessage(commonButtonMessages.linkToLogin)} onClick={goToLoginFromRegistration} />
            </div>
          </Card>
        </div>
      </LoginContainer>
      <BannerCookiePolicy />

      <AppDialog open={signIsExpired}>
        <div className='dialog-error'>
          <Icon path={mdiCloseCircleOutline} size={2} color={'red'} />
          <div className='title-dialog'>{formatMessage(commonErrorMessages.errorTitlePopup)}</div>
          <div className='text-dialog'>{formatMessage(signatureAreaUserRegistrationMessages.signExpiredPopup)}</div>
          <div className='button-dialog'>
            <AppButton onClick={handleCloseSignExpiredPopup} label={formatMessage(commonButtonMessages.closeButton)} />
          </div>
        </div>
      </AppDialog>
    </div>
  );
};
